module.exports = __webpack_public_path__ + "static/img/modeling1.2ee15c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modeling1.png
// module id = 6YVD
// module chunks = 2